import { useModulePermission, useRoutePermission } from '../../../hooks/usePermission';

/** Tài nguyên của module van-ban, khớp `van-ban:{resource}:{action}` ở `modules/van-ban/module.yaml`. */
export type TaiNguyenVanBan =
  | 'template'
  | 'processing-unit'
  | 'integration'
  | 'summary'
  | 'compose'
  | 'task-assignment'
  | 'task';

/**
 * Quyền ghi trên một tài nguyên của module van-ban.
 *
 * Đăng nhập thật: đọc đúng mã quyền lớp 3 mà SDK của module kiểm ở backend
 * (`van-ban:template:create`…), vì `me/context` mới cấp `TEXT_CONFIG.READ` cho
 * màn (TODO(G2-D1-6)). Tài khoản mẫu: quyền `TEXT_CONFIG.*` của route như mọi màn.
 * Không đủ quyền thì ẩn mục (ADR-UI-0005).
 */
export function useQuyenVanBan(taiNguyen: TaiNguyenVanBan) {
  const taoRoute = useRoutePermission('CREATE');
  const suaRoute = useRoutePermission('UPDATE');
  const xoaRoute = useRoutePermission('DELETE');
  const tao = useModulePermission(`van-ban:${taiNguyen}:create`);
  const sua = useModulePermission(`van-ban:${taiNguyen}:update`);
  const xoa = useModulePermission(`van-ban:${taiNguyen}:delete`);
  const capLai = useModulePermission('van-ban:integration:rotate-key');
  return {
    canCreate: taoRoute || tao,
    canUpdate: suaRoute || sua,
    canDelete: xoaRoute || xoa,
    /** Cấp lại khoá API là thao tác nhạy cảm, quyền riêng (backend hỏi thẳng user-service). */
    canRotateKey: suaRoute || capLai,
  };
}
